import {
  PAGE,
  RESET_INTERNAL,
  RESET_PAGE,
  RESET_ACTIVE,
  RESET_FILE_TYPE,
  UPDATE_INTERNAL,
  UPDATE_ACTIVE,
  UPDATE_PAGE,
  UPDATE_FILE_TYPE,
  CHANGE_ACTIVE,
  CHANGE_PAGE,
  DROP_REJECTED,
  POST_UPLOAD_FILE,
  POST_UPLOAD_FILE_START,
  POST_UPLOAD_FILE_SUCCESS,
  POST_UPLOAD_FILE_ERROR,
} from './constants'

const resetInternal = () => ({ type: RESET_INTERNAL })
const resetActive = () => ({ type: RESET_ACTIVE })
const resetPage = () => ({ type: RESET_PAGE })
const resetFileType = () => ({ type: RESET_FILE_TYPE })
const updateActive = (active) => ({ type: UPDATE_ACTIVE, active })
const updatePage = (page) => ({ type: UPDATE_PAGE, page })
const updateFileType = (value) => ({ type: UPDATE_FILE_TYPE, value })
const updateInternal = (value) => ({ type: UPDATE_INTERNAL, value })
const changePage = (page) => ({ type: CHANGE_PAGE, page })
const changeActive = (active) => ({ type: CHANGE_ACTIVE, active })
const dropRejected = (files) => ({ type: DROP_REJECTED, files })

const setActive = () => changeActive(true)
const setInactive = () => changeActive(false)
const setFileTypePage = () => changePage(PAGE.TYPE_SELECTION)
const setUploadPage = () => changePage(PAGE.FILE_SELECTION)
const setLoadingPage = () => changePage(PAGE.UPLOADING)

const postUploadFile = (files) => ({ type: POST_UPLOAD_FILE, files })
const postUploadFileStart = () => ({ type: POST_UPLOAD_FILE_START })
const postUploadFileSuccess = () => ({ type: POST_UPLOAD_FILE_SUCCESS })
const postUploadFileError = (error) => ({ type: POST_UPLOAD_FILE_ERROR, error })

export {
  resetInternal,
  resetActive,
  resetPage,
  resetFileType,
  updateActive,
  updatePage,
  updateFileType,
  updateInternal,
  changePage,
  changeActive,
  setActive,
  setInactive,
  setFileTypePage,
  setUploadPage,
  setLoadingPage,
  dropRejected,
  postUploadFile,
  postUploadFileStart,
  postUploadFileSuccess,
  postUploadFileError,
}
